// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Validation_Semigroup from "../Data.Validation.Semigroup/index.js";
import * as Restaumatic_Form_DynamicResult from "../Restaumatic.Form.DynamicResult/index.js";
import * as Restaumatic_Form_Errors from "../Restaumatic.Form.Errors/index.js";
import * as Restaumatic_Form_Result from "../Restaumatic.Form.Result/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var uniqFinal = function (dictMonadFRP) {
    var map1 = Data_Functor.map(((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0());
    var uniqDynBy = Specular_FRP_Base.uniqDynBy(dictMonadFRP);
    return function (dictEq) {
        var $20 = map1(Restaumatic_Form_DynamicResult.wrap);
        var $21 = uniqDynBy(Data_Eq.eq(Restaumatic_Form_Result.eqResult(dictEq)));
        return function ($22) {
            return $20($21(Restaumatic_Form_DynamicResult.unwrap($22)));
        };
    };
};
var unFinalV = /* #__PURE__ */ (function () {
    var $23 = map(Restaumatic_Form_Result.toVLax);
    return function ($24) {
        return $23(Restaumatic_Form_DynamicResult.unwrap($24));
    };
})();
var unFinal = /* #__PURE__ */ (function () {
    var $25 = map(Restaumatic_Form_Result.toMaybeLax);
    return function ($26) {
        return $25(Restaumatic_Form_DynamicResult.unwrap($26));
    };
})();
var makeFinalV = /* #__PURE__ */ (function () {
    var $27 = map(Restaumatic_Form_Result.liftV);
    return function ($28) {
        return Restaumatic_Form_DynamicResult.wrap($27($28));
    };
})();
var makeFinal = /* #__PURE__ */ (function () {
    var $29 = map(Data_Maybe.maybe(Data_Validation_Semigroup.invalid(Restaumatic_Form_Errors.unknownError))(Control_Applicative.pure(Data_Validation_Semigroup.applicativeV(Restaumatic_Form_Errors.semigroupFormErrors))));
    return function ($30) {
        return makeFinalV($29($30));
    };
})();
var uniqPureFinal = function (dictEq) {
    var $31 = Specular_FRP_Base.uniqDynPureBy(Data_Eq.eq(Data_Maybe.eqMaybe(dictEq)));
    return function ($32) {
        return makeFinal($31(unFinal($32)));
    };
};
var liftMaybe = /* #__PURE__ */ (function () {
    var $33 = Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
    return function ($34) {
        return makeFinal($33($34));
    };
})();
var liftDynamic = Restaumatic_Form_DynamicResult.liftDynamic;
var invalidFinal = /* #__PURE__ */ Restaumatic_Form_DynamicResult.liftResult(/* #__PURE__ */ Restaumatic_Form_Result.liftV(/* #__PURE__ */ Data_Validation_Semigroup.invalid(Restaumatic_Form_Errors.unknownError)));
var getErrors = /* #__PURE__ */ (function () {
    var $35 = map(Data_Validation_Semigroup.validation(Restaumatic_Form_Errors.formErrorsToArray)(function (v) {
        return [  ];
    }));
    return function ($36) {
        return $35(unFinalV($36));
    };
})();
var bindFinal = function () {
    return Restaumatic_Form_DynamicResult.andThen;
};
export {
    bindFinal,
    getErrors,
    invalidFinal,
    liftDynamic,
    liftMaybe,
    makeFinal,
    makeFinalV,
    unFinal,
    unFinalV,
    uniqFinal,
    uniqPureFinal
};
export {
    FormErrors,
    formErrorsToArray,
    internalError,
    internalErrorForField,
    isEmpty,
    unknownError,
    userVisibleError,
    userVisibleErrors
} from "../Restaumatic.Form.Errors/index.js";
